<div class="snickers-page-container" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
  <div class="container">
  <div class="no-data">
    <p>
      {{language?.No_Data.No_Bracket}}
    </p>
  </div>
  </div>
</div>
